import React, { useState, useEffect, useRef } from 'react';
import { Alert, ProgressBar } from 'react-bootstrap';
import _ from 'lodash';
import useDataApi from '../../utils/useDataApi';
import usePostApi from '../../utils/usePostApi';
import currencyConversion from '../../utils/currencyConversion';

import TopTwenty from './TopTwenty';

const type = 'top20';

export default function (drupalParams) {
  const { case_uuid, canEdit, can_see_details } = drupalParams;
  const [{ data, isLoading, isError }, { setData }] = useDataApi(
    `/ir-search/query-json?query=${type}&case_uuid=${case_uuid}`,
    {}
  );
  const [viewFilters, setViewFilters] = useState({});
  const [claim_total, setClaimTotal] = useState({});
  const [editScheduleForm, setEditScheduleForm] = useState(false);
  const inputRef = useRef(null);

  const transformResponseToData = (item) => {
    let schedule = {};
    schedule = Array.isArray(item.queries)
      ? _.get(item, 'queries[0].top20[0].text', [])
      : _.get(item, 'queries.top20[0].text', []);
    return schedule;
  };

  const [{ data: savedScheduleResponse, isLoading: isLoadingSave, isError: isSaveError }, setPostData] =
    usePostApi('/scheduleform/save');

  useEffect(() => {
    if (savedScheduleResponse) setData(savedScheduleResponse.content);
  }, [savedScheduleResponse]);

  const saveScheduleForm = (values) => {
    let { creditors = [{}] } = values;

    creditors = creditors.map((creditor) => ({
      creditor_name: creditor.creditor_name || '',
      creditor_address_street: creditor.creditor_address_street || '',
      creditor_address_city: creditor.creditor_address_city || '',
      creditor_address_state: creditor.creditor_address_state || '',
      creditor_address_zip_code: creditor.creditor_address_zip_code || '',
      creditor_address_country: creditor.creditor_address_country || '',

      contact_address: creditor.contact_address ? creditor.contact_address : '',

      total: currencyConversion.toCentsOrStr(creditor.total),
      deduction: currencyConversion.toCentsOrStr(creditor.deduction),
      unsecured: currencyConversion.toCentsOrStr(creditor.unsecured),
      claim_type: creditor.claim_type ? creditor.claim_type : '',
      claim_status: creditor.claim_status ? creditor.claim_status : '',
    }));

    const creditorsData = {
      creditors,
    };

    setPostData({
      case_uuid,
      type,
      data: creditorsData,
    });
    setEditScheduleForm(false);
  };

  const toggleScheduleForm = () => {
    setEditScheduleForm(!editScheduleForm);
  };
  const onPastedData = (schedule) => {
    setEditScheduleForm(schedule);
  };

  if (isLoading || isLoadingSave) {
    return <ProgressBar now={100} bsStyle="info" label={`${isLoadingSave ? 'Saving in progress' : ''}`} active />;
  }

  if (isError) {
    return <Alert bsStyle="danger">There has been an error loading Schedule data.</Alert>;
  }
  if (isSaveError) {
    return (
      <Alert bsStyle="danger">
        There has been an error saving Schedule data.
        <pre>{`${isSaveError}`}</pre>
      </Alert>
    );
  }
  const scheduleFiltersProps = {
    inputRef,
    viewFilters,
    setViewFilters,
  };

  return (
    <TopTwenty
      schedule={transformResponseToData(data)}
      scheduleFiltersProps={scheduleFiltersProps}
      canEdit={canEdit}
      can_see_details={can_see_details}
      type={type}
      editScheduleForm={editScheduleForm}
      toggleScheduleForm={toggleScheduleForm}
      viewFilters={viewFilters}
      onSubmit={(value) => saveScheduleForm(value)}
      onCancel={toggleScheduleForm}
      onPastedData={onPastedData}
      claim_total={claim_total}
      setClaimTotal={setClaimTotal}
    />
  );
}



// WEBPACK FOOTER //
// ./src/scheduleform/schedule_top20/TopTwentyContainer.jsx